var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEcoJusticeorganization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1210 1210",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M744.86 194.18s-51.43 45.76-139.9 47.53c-88.46-1.77-139.82-47.53-139.82-47.53L113.47 298.2l35.26 194.9 143.3-17.61v540.33H917.9V475.49l143.37 17.61 35.25-194.9ZM408.99 521.54H792.6v85.99H409Zm383.63 264.34H409v-85.96h383.62v85.96z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoJusticeorganization);
export default __webpack_public_path__ + "static/media/Eco-justice organization.05ecd75c2a2557b73bd7ac394fc73ead.svg";
export { ForwardRef as ReactComponent };